require('./catalog.less');
require('./../plugins/jquery.loader/require.js');
require('./priceslider/priceslider.js');
import Trackers from './tracker/tracker';
import Events from './tracker/events';

jQuery(function() {
    var $objItemListContainer = $('.js-products-container');

    /** при изменении кол-ва товаров на странице */
    $(document).on('change', '.pagination__size form select', function() {
        var params = getSupportData();
        params['count'] = $(this).val();
        window.mxLoader && window.mxLoader.show();
        updateListAfterFilter(params);
    });

    /** при изменении сортировки */
    $(document).on('change', 'form #catalog-sort', function() {
        var params = getSupportData();
        params['sort'] = $(this).val();
        window.mxLoader && window.mxLoader.show();
        updateListAfterFilter(params);
    });

    /** при переходе в постраничной навигации */
    $(document).on('click', '.pagination__item', function(e) {
        var params = getSupportData();
        e.preventDefault();
        window.mxLoader && window.mxLoader.show();
        params['history-link'] = params['history-link'].replace(/&page=([\d]+)/, '');
        params['page_url'] = $(this).attr('href');
        if (params['page_url'].indexOf('?') + 1) {
            updateListAfterFilter(params, true);
        } else {
            updateListAfterFilter(params, false);
        }
    });

    /** при изменении значений фильтра (инпутов) */
    $(document).on('change', '.filter input', function(e) {
        e.preventDefault();
        var params = getSupportData();
        var position = $(this).offset();
        $.ajax({
            url: '/ajax/action/catalog_filter/ajaxFilter/',
            data: $('form.js-section-filter').serialize() + '&top=' + position.top + '&' + params['price_filter'],
            success: function(result) {
                disableCheckbox(result.data['PROPS_ACTIVE']);
                showPopup(result.html);
                updateFilterSubmitButton(result.data);
            }
        });
    });

    /** при клике по фильтру цены */
    $(document).on('click', '.filter .priceslider__line', function(e) {
        e.preventDefault();
        var params = getSupportData();
        var position = $(this).offset();
        $.ajax({
            url: '/ajax/action/catalog_filter/ajaxFilter/',
            data: $('form.js-section-filter').serialize() + '&top=' + position.top + '&' + params['price_filter'],
            success: function(result) {
                disableCheckbox(result.data['PROPS_ACTIVE']);
                showPopup(result.html);
                updateFilterSubmitButton(result.data);
            }
        });
    });

    /** Если зажата мышка и мы покидаем облость фильтра цены */
    $(document).on('mouseleave', '.filter .priceslider__line', function(e) {
        if (e.which == 1) {
            e.preventDefault();
            var $this = $(this);
            /* На таймаут, чтобы сработало гарантированно позже события click - иначе вознникает конкуренция и в рез-те в фильтр передаются неверные значения */
            window.setTimeout(function() {
                var params = getSupportData();
                var position = $this.offset();
                $.ajax({
                    url: '/ajax/action/catalog_filter/ajaxFilter/',
                    data:
                        $('form.js-section-filter').serialize() + '&top=' + position.top + '&' + params['price_filter'],
                    success: function(result) {
                        disableCheckbox(result.data['PROPS_ACTIVE']);
                        showPopup(result.html);
                        updateFilterSubmitButton(result.data);
                    }
                });
            }, 500);
        }
    });

    /** При клике применить фильтр */
    $(document).on('click', '.js-filter-apply', function(e) {
        var params = getSupportData();
        params['filter'] = $(this).data('filter');
        params['history-link'] = $(this).data('history-link');
        params['filter_props'] = '';
        e.preventDefault();
        window.mxLoader && window.mxLoader.show();
        updateListAfterFilter(params);
        let trackers = new Trackers();
        trackers.onPMbtnFilter();
    });

    $(document).on('click', 'form.js-section-filter input[type="submit"]', function(e) {
        var params = getSupportData();
        params['filter'] = $(this).data('filter');
        params['history-link'] = $(this).data('history-link');
        params['filter_props'] = '';
        e.preventDefault();
        window.mxLoader && window.mxLoader.show();
        updateListAfterFilter(params);
    });

    $(document).on('change', '.js-price-filter-apply', function(e) {
        e.preventDefault();
        var params = getSupportData();
        params['price_filter'] = $('form.js-price-filter').serialize();

        /* проверка - если есть фильтр на странице */
        var smartFilter = false;
        if ($('.catalog__filter-column').length > 0) {
            smartFilter = true;
        }
        window.mxLoader && window.mxLoader.show();
        if (smartFilter) {
            /* применяем фильтр */
            $.ajax({
                url: '/ajax/action/catalog_filter/ajaxFilter/',
                data: $('form.js-section-filter').serialize() + '&' + params['price_filter'],
                success: function(result) {
                    params['filter'] = result.data['ELEMENT_ID_LIST'];
                    params['history-link'] = result.data['HISTORY_LINK'];
                    updateFilterSubmitButton(result.data);
                    /* обновляем список товаров*/
                    updateListAfterFilter(params);
                }
            });
        } else {
            updateListAfterFilter(params);
        }
    });

    function disableCheckbox(propData) {
        $.each($('form.js-section-filter input[type="checkbox"]'), function(e, propValue) {
            if (!$(propValue).is(':checked')) {
                var propertyID = $(propValue).data('prop-id');
                if (propData[propertyID] === undefined) {
                    $(propValue).attr('disabled', true);
                    $(propValue)
                        .parent()
                        .find('label')
                        .addClass('styledbox__label--disabled');
                } else if (propData[propertyID][propValue.value] === undefined) {
                    $(propValue).attr('disabled', true);
                    $(propValue)
                        .parent()
                        .find('label')
                        .addClass('styledbox__label--disabled');
                } else {
                    $(propValue).attr('disabled', false);
                    $(propValue)
                        .parent()
                        .find('label')
                        .removeClass('styledbox__label--disabled');
                }
            }
        });
    }

    /**
     * убирает старое окно с данными о фильтрации, показывает новое окно
     * @param data - вертска окна
     */
    function showPopup(data) {
        $('.js-filter-popup').remove();
        $(data).appendTo('body');
    }

    /**
     * Устаналивает ссылку в браузере
     */
    function setHistoryLink() {
        var $objSupportBlock = $('.js-catalog-data');
        history.replaceState(null, null, $objSupportBlock.data('url'));
    }

    /**
     * Обновлаяет значение кнопки применить форму
     * @param data
     */
    function updateFilterSubmitButton(data) {
        var $submitBtn = $('form.js-section-filter input[type="submit"]');
        if (data['ELEMENT_COUNT'] > 0) {
            $submitBtn.attr('disabled', false);
        } else {
            $submitBtn.attr('disabled', true);
        }
        $submitBtn.data('filter', data['ELEMENT_ID_LIST']);
        $submitBtn.data('history', data['HISTORY_LINK']);
    }

    /**
     * Получение вспомогательной информации из атрибутов
     * @returns {*}
     */
    function getSupportData() {
        var $objSupportBlock = $('.js-catalog-data');
        var params = [];
        params['sort'] = $objSupportBlock.data('sort');
        params['section'] = $objSupportBlock.data('section');
        params['count'] = $objSupportBlock.data('count');
        params['history-link'] = $objSupportBlock.data('url');
        params['filter'] = $objSupportBlock.data('filter');
        params['filter_props'] = $objSupportBlock.data('filter_props');
        params['template_url'] = $objSupportBlock.data('template_url');
        params['page_url'] = $objSupportBlock.data('page_url');
        params['section_path'] = $objSupportBlock.data('section_code_path');
        params['price_filter'] = $('form.js-price-filter').serialize();
        return params;
    }

    //Объявляем стилизацию селекта
    var styleSelects = function($select) {
        $select.each(function() {
            var $this = $(this);
            $this
                .select2({
                    language: 'ru',
                    minimumResultsForSearch: Infinity,
                    dropdownParent: $this.parent()
                })
                .on('select2:open', function() {
                    var $options = $this
                        .parent()
                        .find('.select2-container--default .select2-results > .select2-results__options');
                    $options.mCustomScrollbar('destroy');
                    $options.mCustomScrollbar('update');
                    setTimeout(function() {
                        $options.mCustomScrollbar({
                            axis: 'y',
                            scrollbarPosition: 'inside',
                            advanced: {
                                updateOnContentResize: true
                            },
                            live: true
                        });
                    }, 0);
                });
        });
    };

    styleSelects($('.js-styled-select'));

    function updateListAfterFilter(params, href) {
        var queryData;
        if (href === true) {
            queryData =
                params['page_url'] +
                '&' +
                params['history-link'] +
                '&' +
                params['price_filter'] +
                '&' +
                params['filter_props'];
        } else {
            queryData =
                params['page_url'] +
                '?' +
                params['history-link'] +
                '&' +
                params['price_filter'] +
                '&' +
                params['filter_props'];
        }
        $.ajax({
            type: 'POST',
            url: ('/ajax/component/' + params['template_url'] + queryData).replace(/\/\/+/g, '/'),
            data: {
                ELEMENT_COUNT: params['count'],
                SECTION_CODE: params['section'],
                SECTION_CODE_PATH: params['section_path'],
                sort: params['sort'],
                FILTER: params['filter']
            },
            success: function(result) {
                $('.js-filter-popup').remove();
                window.mxLoader && window.mxLoader.hide(0);
                $objItemListContainer.html(result.html);
                setHistoryLink();
                $('html,body').animate({ scrollTop: $objItemListContainer.offset().top }, 500);
                styleSelects($('.js-styled-select'));
                let event = new Events();
                event.init();
            }
        });
    }
});



// WEBPACK FOOTER //
// ./blocks/catalog.js